export default __webpack_public_path__ + "static/media/ReviewReply.d5e19dfa.svg";